
import { AnimatePresence,  } from 'framer-motion';
// import { useState } from 'react';
import Modal from './model';
// import { FaArrowRight } from 'react-icons/fa6';
import { PropTypes } from 'prop-types';
import { useEffect } from 'react';

const ModelButton = ({ children,modalOpen,close,css }) => {
   

    //stop scroll when model is open
//    useEffect(()=>{
//     if (typeof window !== 'undefined') {
//         if (modalOpen) {
//             document.body.style.overflow = "hidden";
//             document.body.style.zIndex = "-1";
//             document.querySelector("#root > div > div").classList.remove("z-30")
           
//         } else {
//             document.body.style.overflow = "unset";
//             document.body.style.zIndex = "unset";
//             document.querySelector("#root > div > div").classList.add("z-30")
//         }
//     }
//    },[modalOpen])

    return (
        <>

            <AnimatePresence
                initial={false}
                mode={'wait'}
                onExitComplete={close}
            >
                {modalOpen && <Modal css={css} modalOpen={modalOpen} handleClose={close} >
                    {children}
                </Modal>
                }
            </AnimatePresence>

        </>
    )
}
ModelButton.propTypes = {
    children: PropTypes.node,
    modalOpen: PropTypes.bool,
    close: PropTypes.func
}
export default ModelButton